export const CANDIDATE_MAX_ERROR = 500;
export const DEFAULT_MAXIMUMSCREENSPACEERROR = 16;
